<template>
	<div id="auth_page" style="width: 100%;background-color:e60012;">
		<img src="/img/authpage.jpg" width="100%"/>
		<div style="position: absolute;bottom: 3rem;width: 100px;text-align: center;left:50%;margin-left: -50px;background: rgba(0, 0, 0, 0.3);border-radius: 1.239994rem;color:#FFFFFF;">授权中</div>
		</div>
</template>

<script>
import {api_user} from '@/common/Request.js';
	export default {
	data () {
	  return {
	    value: '',
		user_token:''
	  }
	},
	mounted(){
		//document.getElementById("auth_page").style.height=document.documentElement.clientHeight+"px";
		//console.log(document.getElementById("auth_page").style.height);
		if(this.$route.query.openid==null){
			if(!this.$cookies.isKey("wx_token"))
			{
				location.href="http://weixin.huazhi.cn/wx_login.php";
			}
			else{
				this.usertokencheck();
			}
		}
		else{

			console.log(this.$route.query);
			this.$cookies.set("wx_token",this.$route.query.openid);
			this.$cookies.set("wx_nickname",this.$route.query.nickname);
			this.$cookies.set("wx_headimgurl",this.$route.query.headimgurl);
			console.log(this.$route.query.openid);
			console.log(this.$route.query.nickname);
			console.log(this.$route.query.headimgurl);
			this.usertokencheck();

		}
	},
	methods:{
		usertokencheck()
		{
				api_user.wxlogin(this.$cookies.get("wx_token")).then(response => {
			    console.log(response.data);
				if(response.code==0)
				{
					this.user_token=response.data;
					this.$cookies.set("user_token",this.user_token);
					this.$router.push(this.$cookies.get("beforeLoginUrl"));
				}
				else{
					this.$router.push("/auth_binding");
				}

					})
			.catch(err=>{
				console.log(err);
			})
		}
	}
}
</script>

<style>
</style>
